import { Icon } from '@eti/components';
import { css } from '@eti/styles';
import { Dialog, Button } from '@etg/wings';
import type { Filters } from 'providers/src/search/SearchContext';
import { useToggle } from '../../../../../common/custom-hooks/toggle';
import type { AvailableSortTypesType } from '../../../models';
import DebugFilters from './DebugFilters';
import SortTypes from './SortTypes';
import type { ResultFilter } from './models';

interface ResultPageDebugToolsProps {
  availableSortTypes: AvailableSortTypesType;
  debugFilters: ResultFilter[];
  filteredFlightsCount: number;
  flightsCount: number;
  onFilter: (filter: ResultFilter) => void;
  onResetAll?: () => void;
  onSort?: (value: string) => void;
  selectedFilters: Filters | undefined;
  selectedSortType?: string;
}

const toggleButtonClass = css`
  border-bottom-left-radius: 0;
  border-top-left-radius: 0;
  left: -1px;
  padding-left: 0.5rem;
  position: fixed;
  top: 100px;
  z-index: 40;
`;

const ResultPageDebugTools = ({
  availableSortTypes,
  debugFilters = [],
  filteredFlightsCount,
  flightsCount,
  onFilter,
  onResetAll,
  onSort,
  selectedFilters,
  selectedSortType,
}: ResultPageDebugToolsProps) => {
  const { isOpen, handleToggle, handleClose } = useToggle(false);

  return (
    <>
      <Dialog
        className={isOpen ? 'open' : 'closed'}
        isOpen={isOpen}
        onDismiss={handleClose}
        title="Filters"
      >
        <div>
          <SortTypes
            availableSortTypes={availableSortTypes}
            onSort={onSort ?? (() => {})}
            selectedSortType={selectedSortType ?? ''}
          />
          <DebugFilters
            availableFilters={debugFilters}
            filteredFlightsCount={filteredFlightsCount}
            flightsCount={flightsCount}
            onFilter={onFilter}
            onResetAll={onResetAll}
            selectedFilters={selectedFilters}
          />
        </div>
      </Dialog>
      <Button
        className={toggleButtonClass}
        data-testid="resultPage-debugTools-toggleButton-button"
        iconPrefix={<Icon color="#307be8" id="filter" size="1rem" />}
        onClick={handleToggle}
        size="small"
      >
        Filters
      </Button>
    </>
  );
};

export default ResultPageDebugTools;
